import React from 'react';

const AdvisorContext = React.createContext();
export default AdvisorContext;
